import { produce } from "immer";

const initialState = {

    width: 0,
    height: 0,

};

const layoutReducer = produce((draft = initialState, action) => {

    const { type, payload } = action;

    switch (type) {

        case 'width': {
            draft.width = payload;
            return draft;
        }

        case 'height': {
            draft.height = payload;
            return draft;
        }

        default: return draft;
    }

});

export default layoutReducer;
